"use client";

import { useServerInsertedHTML } from "next/navigation";

interface Props {
    id: string;
    type?: string;
    children: string;
}

export default function InlineScript({ id, type, children }: Props) {
    useServerInsertedHTML(() => (
        <script
            id={id}
            type={type}
            dangerouslySetInnerHTML={{ __html: children }}
        />
    ));
    return null;
}
